import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// myalgo = https://algoindexer.testnet.algoexplorerapi.io/v2/
// algonode = https://testnet-idx.algonode.cloud/v2/
export const myAlgoApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: 'https://mainnet-idx.4160.nodely.dev/' }),
  // baseQuery: fetchBaseQuery({ baseUrl: 'https://algoindexer.testnet.algoexplorerapi.io/v2/' }),
  keepUnusedDataFor: 300,
  tagTypes: ['Accounts', 'Assets', 'Transactions'],
  endpoints: (builder) => ({
    getAccountByAddress: builder.query({
      query: (address: string) => `accounts/${address}`,
      providesTags: ['Accounts'],
    }),
    getAssetById: builder.query({
      query: (id: number | string) => `assets/${id}`,
      providesTags: ['Assets'],
    }),
    getTransactionsByAddress: builder.query({
      query: ({ address, nextToken }) =>
        `accounts/${address}/transactions?limit=16&next=${nextToken}`,
      providesTags: ['Transactions'],
    }),
    getAccountAtRound: builder.query({
      query: ({ address, round }) => `accounts/${address}?round=${round}`,
    }),
    getIconList: builder.query({
      query: () => {
        return { url: 'https://asa-list.tinyman.org/assets.json' };
      },
    }),
    getNewAssetByUnit: builder.query({
      query: (unitName: string) => `assets?unit=${unitName}`,
    }),
    getNewAssetByName: builder.query({
      query: (name: string) => `assets?name=${name}`,
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetAccountByAddressQuery,
  useGetAssetByIdQuery,
  useGetTransactionsByAddressQuery,
  useGetIconListQuery,
  useGetAccountAtRoundQuery,
  useGetNewAssetByNameQuery,
  useGetNewAssetByUnitQuery,
} = myAlgoApi;

export const useFilteredAssetsByAccount = (assetIndex: number, sender: string) => {
  const { data } = useGetAccountByAddressQuery(sender, {
    selectFromResult: ({ data, error, isLoading, isFetching }) => ({
      data: data?.account.assets.find((asset: any) => asset['asset-id'] === assetIndex),
      error,
      isLoading,
      isFetching,
    }),
  });

  return data;
};

export const useGetIconById = (assetIndex: number) => {
  const { data } = useGetIconListQuery('', {
    selectFromResult: ({ data }) => ({
      data: data?.[assetIndex],
    }),
  });

  return data;
};
